export const OBJECTIVES_PROMPT_NAME = 'determineObjectives';
export const AMERICAN_OBJECTIVES_PROMPT_NAME = 'americanObjectives';
